export default "__VITE_ASSET__CKVBSlM4__"